import React from 'react';
import { useHistory } from 'react-router-dom';
import { AppUtils, Utilities } from '@gscope-mfe/app-bridge';
import { useTranslation } from 'react-i18next';
import classes from './StrideNavigation.module.css';
import ExpandedPanel from './ExpandedPanel/ExpandedPanel';
import StrideProfile from './StrideProfile/StrideProfile';
import StrideMarket from './StrideMarket/StrideMarket';
import logo from '../assets/logo-stride-color.png';
import Loader from '../../Loader';
import StrideIcon from '../assets/index';
import { CustomToolTip } from '../../ToolTips';

const StrideNavigation = ({ strideBuckets }) => {
    const [focusIndex, setFocusIndex] = React.useState(0);
    const [showPanel, setShowPanel] = React.useState(false);
    const [showProfile, setShowProfile] = React.useState(false);
    const [expandedPanel, setExpandedPanel] = React.useState(false);
    const [moduleOverflown, setModuleOverflown] = React.useState([]);
    const [moduleCount, setModuleCount] = React.useState(0);
    const [currentBucket, setCurrentBucket] = React.useState({});
    const [strideTitle, setStrideTitle] = React.useState('');
    const [showMarket, setShowMarket] = React.useState(false);
    const [selectedMarket, setSelectedMarket] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const { t } = useTranslation('commonLang');
    const history = useHistory();
    const refEl = React.useRef();
    const marketRef = React.useRef();
    const refMore = React.useRef();
    const refOverflow = React.useRef();
    const profileTabStride = React.useRef();
    const { currentMarket, currentPage, bucketsLookup } = AppUtils.get();
    const panelToggle = () => {
        setShowPanel(true);
        setShowProfile(false);
        setShowMarket(false);
    };

    const findTopValue = (elementToPosition, referenceEl) => {
        if (!referenceEl || !elementToPosition) return;

        const refeleTop = referenceEl.getBoundingClientRect().top;

        let eleBtm = window.innerHeight - referenceEl.getBoundingClientRect().bottom;
        if (eleBtm < 0) eleBtm = 0;

        const eleHeight = elementToPosition.offsetHeight + 10;
        if (!elementToPosition.style) elementToPosition[style] = {};
        const vwHeight = window.innerHeight;
        let topValueOfRef = 0;
        if (vwHeight - refeleTop > eleHeight) {
            //we have space to fit in the element and have it expanded downward
            topValueOfRef = `${refeleTop}px`;
        } else if (vwHeight - eleBtm > eleHeight) {
            //we have space to fit in the element and expand it upward
            let yPos = vwHeight - eleBtm - elementToPosition.offsetHeight;
            if (yPos < 0) yPos = 0;
            topValueOfRef = `${yPos}px`;
        } else {
            if (vwHeight - refeleTop > vwHeight - eleBtm) {
                topValueOfRef = `${refeleTop}px`;
                elementToPosition.style.maxHeight = `calc(100vh - ${refeleTop}px)`;
            } else {
                elementToPosition.style.maxHeight = `calc(100vh - ${eleBtm}px)`;
                let yPos = vwHeight - eleBtm - elementToPosition.offsetHeight;
                if (yPos < 0) yPos = 0;
                topValueOfRef = `${yPos}px`;
            }
        }
        elementToPosition.style.top = topValueOfRef;
    };
    const navigateToPage = (route, index) => {
        setShowPanel(false);
        setFocusIndex(index);
        history.push(route);
    };
    const overflowClick = (value, focusId) => {
        setFocusIndex(focusId);
        setShowProfile(false);
        setShowPanel(false);
        setShowMarket(false);
        history.push(value.route);
    };
    const showMarketMenu = () => {
        setShowProfile(false);
        setShowPanel(false);
        setShowMarket(true);
    };

    const showProfileOnMouseEnter = () => {
        setShowPanel(false);
        setShowProfile(true);
        setShowMarket(false);
    };
    const expandPanel = () => {
        setExpandedPanel(true);
        setShowMarket(false);
        setShowProfile(false);
    };

    React.useEffect(() => {
        setSelectedMarket(currentMarket);
    }, [currentMarket]);

    React.useEffect(() => {
        let noOfModules;
        if (refEl.current) {
            noOfModules = Math.floor((window.innerHeight - 363) / 69);
            setModuleCount(noOfModules);
        }
        if (currentBucket && currentBucket.pages && Object.keys(currentBucket.pages).length > noOfModules) {
            let ans = [];
            Object.keys(currentBucket.pages).map((module, index) => {
                if (index >= noOfModules) {
                    ans.push(currentBucket.pages[module]);
                }
            });
            setModuleOverflown(ans);
        } else setModuleOverflown([]);
    }, [currentBucket]);

    React.useEffect(() => {
        currentBucket &&
            currentBucket.pages &&
            Object.keys(currentBucket.pages).map((pg, index) => {
                if (currentBucket.pages[pg].name == currentPage.name) {
                    setFocusIndex(index);
                }
            });
    }, [currentPage, currentBucket]);

    React.useEffect(() => {
        let currentBucketCp = {};
        if (
            currentPage &&
            bucketsLookup &&
            Object.keys(bucketsLookup).length &&
            bucketsLookup['stride'] &&
            bucketsLookup['stride']['pages']
        ) {
            for (let strideModule in bucketsLookup['stride']['pages']) {
                if (bucketsLookup['stride']['pages'][strideModule]['pages']) {
                    for (let stridePg in bucketsLookup['stride']['pages'][strideModule]['pages']) {
                        if (
                            bucketsLookup['stride']['pages'][strideModule]['pages'][stridePg].name ==
                                currentPage.name &&
                            bucketsLookup['stride']['pages'][strideModule]['pages'][stridePg].route == currentPage.route
                        ) {
                            currentBucketCp = bucketsLookup['stride']['pages'][strideModule];
                        }
                    }
                } else {
                    if (
                        currentPage.name == bucketsLookup['stride']['pages'][strideModule].name &&
                        currentPage.route == bucketsLookup['stride']['pages'][strideModule].route
                    ) {
                        currentBucketCp = bucketsLookup['stride']['pages'][strideModule];
                    }
                }
            }
        }

        let currentStrideBucketCp = { ...currentBucketCp };
        if (currentBucketCp && currentBucketCp.pages) {
            currentStrideBucketCp['pages'] = Object.keys(currentBucketCp.pages)
                .sort((a, b) => {
                    if (currentBucketCp.pages[a].sNo < currentBucketCp.pages[b].sNo) return -1;
                    else if (currentBucketCp.pages[a].sNo > currentBucketCp.pages[b].sNo) return 1;
                })
                .reduce((accumulator, currentValue) => {
                    accumulator[currentValue] = currentBucketCp.pages[currentValue];
                    return accumulator;
                }, {});
        }

        if (Object.keys(currentStrideBucketCp).length > 0) {
            setCurrentBucket(currentStrideBucketCp);
            const nameArray = currentStrideBucketCp?.name.split(' ') || [];
            if (nameArray.length === 0) {
                return;
            }
            let ans = '';
            for (let i = 0; i < nameArray.length; i++) {
                ans = ans + '' + nameArray[i][0];
            }
            setStrideTitle(ans);
        }
    }, [currentPage, bucketsLookup]);

    React.useLayoutEffect(() => {
        if (showPanel) {
            findTopValue(refOverflow.current, refMore.current);
        }
    }, [showPanel, refMore.current]);

    return (
        <React.Fragment>
            <Loader show={isLoading} />
            {!expandedPanel ? (
                <div id="stride" data-testid="collapsedNav" ref={refEl} className={classes.leftNav}>
                    {(showPanel || showProfile || showMarket) && (
                        <div
                            data-testid="overlayCollapsed"
                            className={classes.overlay}
                            onClick={() => {
                                setShowPanel(false);
                                setSelectedMarket(currentMarket);
                                setShowMarket(false);
                                setShowProfile(false);
                            }}
                        ></div>
                    )}
                    <div>
                        <div className={classes.logo} onClick={expandPanel} data-testid="strideLogo">
                            <div className={classes.currentMarketHolder}>
                                <span>
                                    {t(currentMarket) == currentMarket ? currentMarket.toUpperCase() : t(currentMarket)}
                                </span>
                            </div>
                            <div>
                                <img src={logo} alt="Logo" height={32} width={44} />
                            </div>
                        </div>
                        <div className={classes.moduleName}>
                            <span>{t(strideTitle) == strideTitle ? strideTitle : t(strideTitle)}</span>
                        </div>
                        <hr className={classes.horizontal} />
                    </div>
                    <div data-testid="stride-moduleSection" className={classes.modulesSection}>
                        {currentBucket &&
                            Object.keys(currentBucket).length > 0 &&
                            currentBucket.pages &&
                            Object.keys(currentBucket.pages).map((module, index) => {
                                if (index + 1 <= moduleCount) {
                                    return (
                                        <CustomToolTip
                                            placement="right-start"
                                            title={
                                                t(currentBucket.pages[module].navKey) ==
                                                currentBucket.pages[module].navKey
                                                    ? currentBucket.pages[module].name
                                                    : t(currentBucket.pages[module].navKey)
                                            }
                                            arrow
                                        >
                                            <div
                                                key={index}
                                                data-testid={`module${index}`}
                                                className={classes.navItemThumbnail}
                                                onClick={() => {
                                                    navigateToPage(currentBucket.pages[module].route, index);
                                                }}
                                            >
                                                {/* <i className={`${classes["sct-icon"]} sct-icon icon-Home-181x`} /> */}
                                                <div
                                                    className={
                                                        index == focusIndex ? `${classes.focus}` : classes.notFocus
                                                    }
                                                >
                                                    <StrideIcon name={currentBucket.pages[module].icon} />
                                                    <span className={classes.menuLabel}>
                                                        {t(currentBucket.pages[module].navKey) ==
                                                        currentBucket.pages[module].navKey
                                                            ? currentBucket.pages[module].name
                                                            : t(currentBucket.pages[module].navKey)}
                                                    </span>{' '}
                                                </div>
                                            </div>
                                        </CustomToolTip>
                                    );
                                }
                            })}
                        {currentBucket && Object.keys(currentBucket).length > 0 && !currentBucket.pages && (
                            <CustomToolTip
                                placement="right-start"
                                title={
                                    t(currentBucket.navKey) == currentBucket.navKey
                                        ? currentBucket.name
                                        : t(currentBucket.navKey)
                                }
                                arrow
                            >
                                <div
                                    data-testid="bucketWithoutPg"
                                    className={`${classes.navItemThumbnail} ${classes.focus}`}
                                >
                                    <StrideIcon name={currentBucket.icon} />
                                    <span className={classes.menuLabel}>
                                        {t(currentBucket.navKey) == currentBucket.navKey
                                            ? currentBucket.name
                                            : t(currentBucket.navKey)}
                                    </span>{' '}
                                </div>
                            </CustomToolTip>
                        )}
                    </div>
                    <div>
                        {moduleOverflown.length > 0 && (
                            <div
                                data-testid="view-More"
                                ref={refMore}
                                style={showPanel ? { backgroundColor: '#0071dc' } : {}}
                                className={classes['view-more-text']}
                                onClick={panelToggle}
                            >
                                <i className={`sct-icon icon-Arrow-Down-18 `}></i>
                                <span className={classes['view-more-span']}>{t('more')}</span>
                            </div>
                        )}
                        <div className={classes.lowerSection} data-testid="stride-lastSection">
                            <div
                                data-testid="marketTabStride"
                                style={showMarket ? { backgroundColor: '#0071dc' } : {}}
                                ref={marketRef}
                                onClick={showMarketMenu}
                                className={classes.navItemThumbnail}
                            >
                                <i className={`${classes['sct-icon']} icon-Globe-181x sct-icon`}></i>
                                {t('markets')}
                            </div>
                            <div
                                data-testid="profileTabStride"
                                style={showProfile ? { backgroundColor: '#0071dc' } : {}}
                                ref={profileTabStride}
                                className={classes.navItemThumbnail}
                                onClick={showProfileOnMouseEnter}
                            >
                                <i className={`${classes['sct-icon']} icon-User-18 sct-icon`}></i>
                                {t('profile')}
                            </div>
                        </div>
                    </div>
                    {showPanel && (
                        <div className={classes.pageDrawer}>
                            <div
                                ref={refOverflow}
                                data-testid="overFlowSection"
                                className={classes.pageContainer}
                                style={{ visibility: 'visible' }}
                            >
                                {moduleOverflown.map((moduleO, i) => {
                                    return (
                                        <div
                                            data-testid={`moduleOverflow${i}`}
                                            key={i}
                                            style={focusIndex == moduleCount + i ? { backgroundColor: '#0071dc' } : {}}
                                            className={classes.overflownModule}
                                            onClick={() => overflowClick(moduleO, moduleCount + i)}
                                        >
                                            {' '}
                                            <StrideIcon name={moduleO.icon} />
                                            <span style={{ marginLeft: '8px' }}>
                                                {t(moduleO.navKey) == moduleO.navKey ? moduleO.name : t(moduleO.navKey)}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {showProfile && (
                        <StrideProfile
                            data-testid="profileSelCollapsed"
                            setShowProfile={setShowProfile}
                            profileTab={profileTabStride}
                            origin="CollapsedPanel"
                        />
                    )}
                    {showMarket && (
                        <StrideMarket
                            data-testid="marketSelCollapsed"
                            marketTab={marketRef}
                            origin="CollapsedPanel"
                            setShowMarket={setShowMarket}
                            selectedMarket={selectedMarket}
                            setSelectedMarket={setSelectedMarket}
                        />
                    )}
                </div>
            ) : (
                <ExpandedPanel
                    data-testid="expandedNav"
                    strideBuckets={strideBuckets}
                    setExpandedPanel={setExpandedPanel}
                    currentStrideBucket={currentBucket}
                />
            )}
        </React.Fragment>
    );
};
export default StrideNavigation;
